import { useContext, useMemo } from "react";
import { LocationControlSettingsContext } from "@contexts/location_control_settings_context.ts";
import LocationControl from "@grnhse/location-control";
import { type LocationType } from "@grnhse/location-control/dist/src/common/types";

export const useLocationControl = (granular: boolean) => {
  const { apiKey, baseUrl, locationTypes } = useContext(LocationControlSettingsContext);

  return useMemo(() => {
    const types: LocationType[] = granular ? locationTypes : ["city"];
    return new LocationControl({ apiKey, baseUrl, locationTypes: types });
  }, [apiKey, baseUrl, locationTypes, granular]);
};
